import { useEffect, useState } from "react";
import { t } from "../i18n";
import { MapPin, CalendarClock } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useModals } from "../context/ModalsContext";
import { Sheet } from "./Sheet";
import { Avatar, Flag } from "./Avatar";
import { fmtFechaHora } from "../lib/data";

export function PendingAppointments() {
  const { unlocked } = useAuth();
  const { bump } = useModals();
  const [items, setItems] = useState([]);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("circulo_pospuesto") === "1");

  useEffect(() => {
    if (!unlocked || hidden) return;
    api.get("/appointments/pendientes-vencidas").then((r) => setItems(r.data)).catch(() => {});
  }, [unlocked, hidden]);

  const resolve = async (id, realizada) => {
    try {
      await api.post(`/appointments/${id}/resolver`, { realizada });
      toast.success(realizada ? t("appt.pendingDone") : t("appt.cancelled"));
      setItems((it) => it.filter((a) => a.id !== id));
      bump();
    } catch (err) { toast.error(errorMessage(err)); }
  };

  const a = items[0];
  if (!unlocked || hidden || !a) return null;
  const p = a.personas?.[0];
  return (
    <Sheet open onClose={() => { sessionStorage.setItem("circulo_pospuesto", "1"); setHidden(true); }} title={t("appt.pendingTitle")} testId="pending-appointment-sheet">
      <div className="flex items-center gap-4 mb-4">
        <Avatar nombre={p?.nombre} src={p?.foto_url} size={64} />
        <div>
          <p data-testid="pending-person-name" className="text-lg font-medium flex items-center gap-2">{a.personas?.map((x) => x.nombre).join(", ")} <Flag iso={p?.pais_iso} size={18} /></p>
          <p className="text-sm text-muted-foreground flex items-center gap-1"><CalendarClock size={14} /> {fmtFechaHora(a.inicio)}</p>
          {a.lugar?.nombre && <p className="text-sm text-muted-foreground flex items-center gap-1"><MapPin size={14} /> {a.lugar.nombre}{a.lugar.ciudad ? `, ${a.lugar.ciudad}` : ""}</p>}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <button data-testid="pending-no-btn" onClick={() => resolve(a.id, false)} className="btn-ghost">{t("common.no")}</button>
        <button data-testid="pending-yes-btn" onClick={() => resolve(a.id, true)} className="btn-primary">{t("appt.pendingYes")}</button>
      </div>
      <button data-testid="pending-later-btn" onClick={() => { sessionStorage.setItem("circulo_pospuesto", "1"); setHidden(true); }} className="w-full mt-3 text-sm text-muted-foreground py-2">{t("common.later")}</button>
      {items.length > 1 && <p className="text-xs text-center text-muted-foreground mt-1">{t("appt.morePending", { n: items.length - 1 })}</p>}
    </Sheet>
  );
}
